module.exports = __webpack_public_path__ + "static/IOT-Exception-Handling-3adad266731f63f1ab5bc39f4ca37e51.jpg";